import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the balance history view.
 * @extends JetView
 */
export default class tableBalanceHistorysView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Marks old values with specific background colors based on their numeric value.
         * @param {number} value - The value to evaluate.
         * @param {Object} config - The configuration object.
         * @returns {Object} CSS styles for the background.
         */
        function mark_old(value, config) {
            var num = webix.Number.parse(value, {
                decimalSize: 2,
                groupSize: 3,
                decimalDelimiter: '.',
                groupDelimiter: ',',
            });
            if (num > 30 && num < 99) {
                return { background: 'orange' }; // Orange background for values between 30 and 99
            }
            if (num > 100) {
                return { background: 'red' }; // Red background for values greater than 100
            }
        }

        console.log($$('select').getValue() * 1); // Logging the selected value from a dropdown

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable component for displaying hierarchical data
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            scheme: {
                                $change: function (item) {
                                    // Change event for item updates
                                    if (item.BalanceEnd != item.BalanceEndCalc) {
                                        item.$css = { background: '#FFAAAA' }; // Highlight background if balances do not match
                                        if (item.BalanceEnd > item.BalanceEndCalc) {
                                            item.BalanceGap = item.BalanceEnd - item.BalanceEndCalc; // Calculate balance gap
                                        } else {
                                            item.BalanceGap = item.BalanceEndCalc - item.BalanceEnd; // Calculate balance gap
                                        }
                                    }
                                },
                            },
                            columns: [
                                {
                                    id: 'Partner', // Column for partner information
                                    header: _('Partner'), // Localized header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj, common) {
                                        // Template for rendering partner names
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) +
                                                "<span class='partner " +
                                                obj.Partner +
                                                "'></span>"
                                            );
                                        return "<span class='partner " + obj.Partner + "'></span>";
                                    },
                                },
                                {
                                    id: 'CreatedLocalDate', // Column for creation date
                                    header: _('Fecha de creación'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 120,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'Country', // Column for country information
                                    header: _('País'), // Localized header
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 80,
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template for rendering country flags
                                        return "<i class='flags " + obj.Country + "'></i>";
                                    },
                                },
                                {
                                    id: 'UserId', // Column for user ID
                                    header: _('ID Usuario'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column for user name
                                    header: _('Nombre Usuario'), // Localized header
                                    width: 150,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BalanceInitial', // Column for initial balance
                                    header: _('Saldo Inicial'), // Localized header
                                    width: 130,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'InitialRechargeQuota', // Column for initial recharge quota
                                    header: _('Cupo recargas inicial'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'InitialGameQuota', // Column for initial game quota
                                    header: _('Cupo juego inicial'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountDeposits', // Column for deposits amount
                                    header: _('Depósitos'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBets', // Column for sports bets amount
                                    header: _('Ap. Deportivas'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWin', // Column for winnings amount
                                    header: _('Pr. Deportivas'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWinCasino', // Column for casino winnings amount
                                    header: _('Transf Apuesta E'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBetsCasino', // Column for casino bets amount
                                    header: _('Transf Apuesta S'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentE', // Column for adjustment E
                                    header: _('Transf Recarga E'), // Localized header
                                    width: 80,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentS', // Column for adjustment S
                                    header: _('Transf Recarga S'), // Localized header
                                    width: 80,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawPaid', // Column for paid withdrawals
                                    header: _('Retiros Pagados'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawDeletes', // Column for deleted recharges
                                    header: _('Recargas Eliminadas'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEnd', // Column for final balance
                                    header: _('Saldo Final'), // Localized header
                                    width: 130,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEndCalc', // Column for calculated final balance
                                    header: _('Saldo Final Calc.'), // Localized header
                                    width: 130,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceGap', // Column for balance gap
                                    header: _('Calc. Desfase'), // Localized header
                                    width: 110,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    cssFormat: mark_old, // Custom formatting function
                                },
                                {
                                    id: 'EndGameQuota', // Column for end game quota
                                    header: _('Cupo'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'EndGameQuotaCalc', // Column for calculated end game quota
                                    header: _('Cupo Calc.'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event when the component is ready
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>', // Show no data message
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: $$('select').getValue() * 1, // Data fetch configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'es/BalanceHistory/GetBalanceHistoryBetShop2'; // API endpoint for fetching balance history
        var filter = ''; // Filter string for API requests

        grid.attachEvent('onAfterLoad', function () {
            // Event after loading data
            $$('datatable').data.group({
                by: 'Partner', // Grouping by Partner
                map: {
                    Partner: ['Partner'], // Mapping for grouping
                },
            });
        });

        this.on(this.app, 'balanceHistory:filter', (filterData) => {
            // Event listener for filtering balance history
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for API request

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (object[i][0] == 'Type') {
                    // Check for Type filter
                    if (object[i][1] == 0) {
                        grid.showColumn('UserId', { spans: true }); // Show UserId column
                        grid.showColumn('UserName', { spans: true }); // Show UserName column
                    } else {
                        grid.hideColumn('UserId', { spans: true }); // Hide UserId column
                        grid.hideColumn('UserName', { spans: true }); // Hide UserName column
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object filter values to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through nested filter entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                        if (object[i][0] === 'Date') {
                            var d = new Date(object[i][1]); // Parse date
                            var dateFrom =
                                'dateFrom=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                ('00' + d.getDate()).slice(-2);
                            string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                            var ud = new Date(object[i][1].getFullYear(), object[i][1].getMonth() + 1, 0); // Get last day of the month
                            var dateTo =
                                'dateTo=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                ('00' + ud.getDate()).slice(-2);
                            string1 = string1 + '&' + dateTo; // Add dateTo to query string
                        }
                    }
                }
            }
            console.log(grid); // Log the grid reference
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + $$('select').getValue() * 1 + string1); // Load new data based on filters
            filter = string1; // Update filter string
        });
    }
}

// FILE DOCUMENTED
